import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminCouponService } from '@/modules/coupon/services/admin-coupon.service'
import { CouponRequestModel } from '@/modules/coupon/models/coupon-request.model'

@vservice()
export class AdminUpdateCouponUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminCouponService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(couponId: number, data: CouponRequestModel) {
    return this.service.updateCoupon(couponId, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
